
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container } from '@/components/ui/container';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import UserPurchases from '@/components/profile/UserPurchases';
import { useAuth } from '@/context/AuthContext';
import AuthSection from '@/components/auth/AuthSection';

const PurchasesPage = () => {
  const navigate = useNavigate();
  const { profile, isAuthenticated } = useAuth();

  const handleGoBack = () => {
    navigate('/profile'); // Or navigate(-1) if preferred
  };

  if (!isAuthenticated || !profile) {
    return (
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <Container className="flex-grow py-10">
          <AuthSection />
        </Container>
        <Footer />
      </div>
    );
  }

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <Container className="flex-grow py-10">
        <div className="flex items-center gap-4 mb-8 mt-8">
          <Button variant="outline" size="icon" onClick={handleGoBack} className="rounded-full">
            <ArrowLeft size={16} />
          </Button>
          <h1 className="text-3xl font-bold">Blerjet e Mia</h1>
        </div>
        <UserPurchases userId={profile.id} />
      </Container>
      <Footer />
    </div>
  );
};

export default PurchasesPage;
